import * as React from 'react';
import {Button} from "../../components/Button";
import ToggleButton from "../../components/ToggleButton";
import SelectField from "../../components/SelectField";
import {TypefamilyDto, WorkflowOptionApprovalDto} from "../../services/Client";
import {Checkbox} from "semantic-ui-react";

interface IApprovalViewHeaderProps {
    optionApprovals: WorkflowOptionApprovalDto[];
    changedApprovals: WorkflowOptionApprovalDto[];
    filterDatasource: TypefamilyDto[];
    filterValue: TypefamilyDto | undefined;
    t: reactI18Next.TranslationFunction;

    allApprovedToggled: boolean;
    hintEnabled: boolean;
    resubmittedRequestsChecked: boolean;

    onSave: () => void;
    handleApproveAll: (toggled: boolean) => void;
    onFilterResubmittedRequestsChange: (checked: boolean) => void;
    onFilterByChange: (newValue: number) => void;
}

export const ApprovalViewHeader: React.StatelessComponent<IApprovalViewHeaderProps> = (props: IApprovalViewHeaderProps) => {
    const FilterByChange = [
        {name: props.t('TEXT'), id: 0}, {name: props.t('ASSIGNMENT'), id: 1}, {name: props.t('RESUBMITTED'), id: 2}
    ];
    return (
        <div id='approval-header' className={`approval-view-header approval-header`}>
            <h2>{props.t("RECENT_APPROVALS")}</h2>
            <span className="openWorkflowItems-content">
                {props.t("START_VIEW:OPENWORKFLOWITEMS_COUNT_START")}
                <span className={"openWorkflowItems-count"}>{props.optionApprovals.length}</span>
                {props.t("START_VIEW:OPENWORKFLOWITEMS_COUNT_END")}
            </span>
            <div className='approval-view-header-items'>
                <div>
                    <Button
                        icon="save"
                        disabled={props.changedApprovals.length === 0 || props.hintEnabled}
                        label={props.t("GLOBAL:SAVE_CHANGES")}
                        onClick={props.onSave}
                    />
                </div>
                <div>
                    <ToggleButton
                        toggled={props.allApprovedToggled}
                        label={props.t("APPROVE_ALL")}
                        icon="check square"
                        disabled={props.optionApprovals.length === 0}
                        onClick={props.handleApproveAll}
                    />
                </div>
                {props.hintEnabled &&
                    <div className='approval-error'>
                        {props.t("GLOBAL:APPROVAL_SAVE_HINT")}
                    </div>
                }
                <div>
                    <div className={'approvalViewHeaderLastChild'}>
                         <h4>{props.t('FILTER_BY_CHANGE')} </h4>
                        <SelectField
                            dataSource={FilterByChange}
                            rendererKey={(value: TypefamilyDto) => {
                                return value.name;
                            }}
                            value={props.filterValue}
                            onChange={props.onFilterByChange}
                            placeholder={`(${props.t('GLOBAL:ALL')})`}
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/ApprovalView/ApprovalViewHeader.tsx